<template>
      <div class="exams-main">
        <div class="hasCategory ">
             <div class="exams-panel">
                <div class="exams-panel-body">
                       <div class="table-toolbar flex align-cen">
                            <div class="table-toolbar-right  flex align-cen">
                                   <div class="table-toolbar-left flex align-cen">
                                <div class="log-exam btnexam"  @click="rebackWrong">返回</div>
                            </div>
                            </div>
                        </div>
                           <div class="public-tit flex align-cen" ref="document" style="margin:20px 16px;">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 错题详情
                            </div>
                            </div>
                  <div class="preview-content">
                       <div class="portlet">
        <div class="portlet-body">
            <div class="duplication-info-container">
                 <div class="ques-title flex align-cen">
                <span class="ques-type">
                         {{$util.getTopicType(detailInfo.type)}}
                </span>
                <div class="qcotent flex align-cen">
                   <p v-html="detailInfo.title" :class="detailInfo.type == 9 ? 'clozeClass' : ''"></p>
                    <AudioTem :audioSrc="audioPro" v-if="audioPro">

                    </AudioTem>
                </div>
                <div class="ques-score">
                    ({{detailInfo.score}}分)
                </div>
            </div>
             <div class="question-option-list">
                    <ol v-if="detailInfo.type != 9 && detailInfo.type != 5">
                        <li v-for="(sonitem,sonIndex) in detailInfo.answerList">
                            <p v-html="sonitem.content"></p>
                        </li>
                    </ol>
                    <div class="refAnswer" style="margin-left:-25px" v-if="detailInfo.type == 5">
                        <div class="detailKeyWorld" v-if="detailInfo.rule">
                           <div class="flex align-cen" style="font-size:16px;color:#999;padding:10px 0">
                            <p>关键字：</p>
                             <p v-for="(item,index) in detailInfo.answerList">
                                {{item.content}}<span v-if="index !=detailInfo.answerList.length-1">，</span>
                            </p>
                           </div>
                        </div>
                        <div class="detailKeyWorld" v-else style="font-size:16px;color:#999;padding:10px 0">关键字:无</div>
                    </div>
                   <div class="clzoe" v-if="detailInfo.type == 9">
                     <div class="clzoeItem" v-for="(item,index) in detailInfo.answerList" :key="index">
                        <p class="cloze-op-p">
                           <strong> {{index + 1}}:</strong>
                        </p>
                        <ol style="margin-left:20px">
                            <li  v-for="(sonitem,sonIndex) in detailInfo.answerList[index].clozeList" :key="sonIndex">
                                <p v-html="sonitem.content"></p>
                            </li>
                        </ol>
                         <p style="color:rgb(153, 153, 153)">解析：{{item.content}}</p>
                     </div>
                   </div>
                </div>
                    <div class="ques-answers">
        <div class="test_result">
            <div class="rightAnswer flex">
                <span v-if="detailInfo.type != 7 && detailInfo.type != 9 && detailInfo.type != 5">
                    正确答案：
                    <span v-for="(sonitem,sonIndex) in detailInfo.answerList">
                        <span  v-if="sonitem.isRight == 1">
                        {{Eng[sonIndex]}}
                    </span>
                    </span>
                </span>
                <span v-if="detailInfo.type == 5" class="flex align-cen" style="color:#009aff">
                    参考答案：
                    <span v-html="detailInfo.refAnswer"></span>
                </span>
                 <span v-if="detailInfo.type == 7">
                    正确顺序：
                    <span v-for="(sonitem,sonIndex) in sortedIndexes">
                        <span>
                        {{Eng[sonitem]}}
                    </span>
                    </span>
                </span>
                <span v-if="detailInfo.type == 9">
                    正确答案：
                    <span v-for="(item,index) in detailInfo.answerList">
                                <span style="margin-right:20px">
                                {{index + 1}}:
                                <span v-for="(sonitem,sonIndex) in detailInfo.answerList[index].clozeList" :key="sonIndex">
                                    <span v-if="sonitem.isRight == 1">{{Eng[sonIndex]}}</span>
                                </span>
                                </span>
                    </span>
                </span>
            </div>
               <div class="analysiCon flex align-cen">
                <span class="label">题目解析：</span>
                <span class="text" v-html="detailInfo.analysis"></span>
               </div>
                 <div class="infoCon flex align-cen" style="color:#999;margin-top:20px;font-size:12px">
                    <span>分类：{{detailInfo.classifyName}}</span> 
                    <span style="margin:0 10px">|</span>
                     <span>标签：{{detailInfo.tag}}</span>
                 </div>
        </div>
    </div>
            </div>
        </div>
                </div>
                    <div class="businessList-container" style="margin:0 16px">
     <div class="businessList-container-table">
                    <el-table
          ref="multipleTable"
          :data="questionList"
          tooltip-effect="dark"
          style="width: 100%"
          border
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
        <el-table-column   label="序号" align="center" >
               <template slot-scope="scope">
              <p>{{scope.$index + 1}}</p>
            </template>
          </el-table-column>
         <el-table-column  prop="paperName" label="试卷名称" align="center" >
          </el-table-column>
          <el-table-column prop="examiner" label="考试人" align="center">
          </el-table-column>
              <el-table-column prop="userScore" label="试卷得分" align="center">
                <template slot-scope="scope">
                       <div>{{scope.row.userScore  ? scope.row.userScore  : '-'}}</div>
                     </template>
          </el-table-column>
           <el-table-column prop="examNum" label="考试结果" align="center">
             <template slot-scope="scope">
                       <div>{{scope.row.result == 1 ? '通过' : scope.row.result == 2 ? '批改中' : '不通过'}}</div>
                     </template>
          </el-table-column>
           <el-table-column  label="批注" align="center">
             <template slot-scope="scope">
                       <div>{{scope.row.notes  ? scope.row.notes  : '-'}}</div>
                     </template>
          </el-table-column>
       </el-table>
        </div>
        </div>
                  </div>
                </div>
             </div>
        </div>
      </div>
</template>
<script>
import {wrongDetail} from "@/api/enterprise/index"   //题目分类、每日答题次数、错题记录
import lineChart from "@/components/lineTemolate/index.vue"; //折线图图组件
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件\
import PieChart from "@/components/pieTemolate/index.vue"; //饼图组件
import mycomponents from "../../utils/compoments.js"
export default {
    name:'wrongBook',
    components:{
      lineChart,
      paginaTion,
      PieChart,
      AudioTem: mycomponents.components.PublicAudio
    },
    data() {
        return {
            businessInfo:{},
            option:[],
            value:'',
            input:'',
            LineChartOption:{},
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            itemList:[],
            detailInfo:{},
            audioPro:'',
            sortedIndexes:[],
            Eng:['A','B','C','D','E','F','G','H','I','J'],
            questionList:[]
        }
    },
    created () {
           if(this.$locaStorage.setAge().get('businessInfo')){
            this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
         }else{
            this.businessInfo = {
                id:this.$route.query.businessId
            }
         }
        this.getwrongDetail()
    },
    methods: {
        rebackWrong(){
          this.$router.push({
            name:'wrongBookIndex',
            query:{
                businessId:this.businessInfo.id
            }
            })
        },
        // 获取答题次数
        getwrongDetail(){
            wrongDetail({businessId:this.businessInfo.id,id:this.$route.query.id})
            .then(res =>{
              this.questionList = res.data.resultQuestionList
              this.detailInfo = res.data.question
              this.audioPro = res.data.question['audio']
                      if(res.data.type == 9){
                    this.detailInfo.answerList.forEach((t,index) => {
                          let patternString = `{{${index + 1}}}`;
                          this.detailInfo.title = this.detailInfo.title.replace(patternString, `__${index + 1}__`)
                    })  
                }
                if(res.data.question.type == 7){
                    // 创建一个包含原数组索引和值的数组  
                        let indexedArray = this.detailInfo.answerList.map((item, index) => ({ item, index }));  
                        // 根据sort值进行排序  
                        indexedArray.sort((a, b) => a.item.sort - b.item.sort);     
                        // 提取排序后的索引  
                        this.sortedIndexes = indexedArray.map(item => item.index);  
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.preview-content{
    position: relative;
    .portlet{
    background: #fafafa;
    padding: 16px 10px !important;
    border-radius: 5px;
    margin: 0 16px;
    .portlet-head{
     border-bottom: 0;
    padding: 0 10px;
    margin-bottom: 0;
    color: #fff;
    }
                         .portlet-body{
                            padding: 10px;
                            .duplication-info-container{
                                .ques-title {
                                    position: relative;
                                    padding-right: 50px;
                                    font-size: 17px;
                                    vertical-align: middle;
                                    line-height: 1.5;
                                    -webkit-margin-before: 0;
                                    -webkit-margin-after: 0;
                                    word-break: break-word;
                                    .ques-type{
                                      background-color: #387dfe;
                                        color: #fff;
                                        padding: 3px 12px;
                                        border: none;
                                        font-size: 12px;
                                        width: 120px;
                                        text-align: center;
                                    }
                                    .qcotent{
                                        padding: 0 10px;
                                        font-size: 15px;
                                    }
                                    .ques-score{
                                        position: absolute;
                                        top: 0px;
                                        right: 10px;
                                        color: #000;
                                    }
                                }
                                .question-option-list{
                                    padding: 0 20px;
                                    margin-top: 10px;
                                    li{
                                        list-style-type: upper-latin;
                                        margin-bottom: 15px;
                                        font-size: 14px;
                                    }
                                    li::marker{
                                       unicode-bidi: isolate;
                                    font-variant-numeric: tabular-nums;
                                    text-transform: none;
                                    text-indent: 0px !important;
                                    text-align: start !important;
                                    text-align-last: start !important; 
                                    }
                                }
                                .ques-answers{
                                    .test_result{
                                        margin-bottom: 8px;
                                       .rightAnswer{
                                            display: block;
                                       } 
                                    }
                                }
                            }
                        }
    }
}
        ::v-deep{
  .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>